// @flow
import * as colors from './colors'

export const rawStyles = {
    mapToolbarActive: {
        '&:active': {
            backgroundColor: colors.secondaryTwo,
        },
        '&:hover': {
            backgroundColor: colors.secondaryTwo,
        },
        color: colors.white,
        backgroundColor: colors.secondaryTwo,
    },
    mapToolbarItem: {
        '&:active': {
            backgroundColor: colors.secondaryTwo,
            color: colors.white,
        },
        '&:hover': {
            backgroundColor: colors.secondaryTwo,
            color: colors.white,
        },
        '&:focus': {
            outline: 'none',
        },
        borderBottom: `1px solid ${colors.gray}`,
        color: colors.textColor,
        cursor: 'pointer',
        display: 'block',
        fontSize: '20px',
        height: '24px',
        padding: '10px',
        textAlign: 'center',
        textDecoration: 'none',
    },
}

export default rawStyles
